import React from "react";
import Paginator from "./Paginator";
import UsersForm from "../Components/Users/UsersForm";
import smile from "../img/users/smile.png"
const FriendsOrUsers = (props) => {
    return(
        <section className='users main-bg'>
            <div className={props.page === "users" ? "users__bg-header" : "friends__bg-header"}>
                <div className={props.page ===  "users" ? "users__header" : "friends__header"}>
                    <div className='users__title title'>
                        <h1>{props.title}</h1>
                        <h3>{props.text}</h3>
                    </div>
                    <div className={props.page ===  "users" ? "users__subtitle" : "friends__subtitle"}>
                        <img src={props.img} alt=""/>
                    </div>
                </div>
            </div>
            <div className="users__container container">
                <div className="users__paginator">
                    <Paginator totalCount={props.totalCount}
                           activePage={props.activePage}
                           setActivePage={props.setActivePage}
                           pageSize={props.pageSize}
                           countPagesInPortion={props.countPagesInPortion}
                    />
                </div>
                <UsersForm onSubmit={props.onSubmit}/>
                <div className="users__cards">
                    {props.people.length > 0 ? props.people :
                        <div className='user__error-search'>
                            <img src={smile} alt=""/>
                            <p className='main-text'>Мы никого не нашли</p>
                        </div>
                    }
                </div>
            </div>
        </section>
    )
};

export default FriendsOrUsers;